<div class="double-selling" *ngIf="order">
  <div class="container">
    <div class="container__information">
      <div class="container__title">
        <div class="row issue__status">
          <span>EN PROCESO</span>
        </div>
        <div class="row issue__id">
          <p>{{ order.issueId }}</p>
        </div>
        <div class="row issue__name" *ngIf="order.issueName">
          <p>{{ order.issueName }}</p>
        </div>
      </div>
      <div class="row">
        <div class="left"><p>Títulos</p></div>
        <div class="right" data-recording-sensitive>
          <p>{{ order.approximatedTitles | hbCustomFormat: '0,0.00000000' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="left"><p>Tipo de orden</p></div>
        <div class="right" data-recording-sensitive>
          <p>{{ order.capitalOrderType }}</p>
        </div>
      </div>
      <div class="row">
        <div class="left"><p>Total aproximado</p></div>
        <div class="right" data-recording-sensitive>
          <p>
            {{
              order.amount
                | hbCustomFormat: (order.amount < 1 ? '$0,0.000' : '$0,0.00')
            }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="left"><p>Fecha de envío</p></div>
        <div class="right" data-recording-sensitive>
          <p>{{ order.createdDate | date: 'dd MMM yyyy' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="left"><p>Hora de envío</p></div>
        <div class="right" data-recording-sensitive>
          <p>{{ order.createdDate | date: 'HH:mm' }} hrs</p>
        </div>
      </div>
    </div>

    <div class="container__actions">
      <div class="usa-order__out-of-service information-card">
        <div class="information-card__container">
          <div
            class="information-card__leading-icon information-card__leading-icon--info"
          ></div>
          <div class="information-card__information">
            <p>
              Si deseas modificar los valores de tu venta antes de que abra el
              mercado, puedes cancelarla desde aquí y efectuar una nueva.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <button
          class="button button--dark"
          (click)="cancelCapitalMarketOrder()"
        >
          Cancelar orden
        </button>
      </div>
    </div>
  </div>
</div>
